import { combineReducers } from 'redux';

import {
    CHANGE_TENANT,
    INVALIDATE_HTTP_DATA,
} from 'actions/typeConstants';

const id = 'name';

const auditHistory = (state = null, action) => {

    switch (action.type) {

    case CHANGE_TENANT:
    case INVALIDATE_HTTP_DATA:

        return null;

    case 'QUEUES_HTTP_SUCCESS':

        if (!action.auditHistory) {
            return state;
        }

        // If this is for an object, return
        if (action.reqObject) {
            return state;
        }

        return Object.assign([], state, action.data);
    default:
        return state;
    };
};

const data = (state = null, action) => {

    switch (action.type) {

    case CHANGE_TENANT:
    case INVALIDATE_HTTP_DATA:

        return null;

    case 'QUEUES_HTTP_SUCCESS':

        if (action.auditHistory) {

            const newState = Object.assign([], state);

            const found = newState.findIndex(obj => obj[id] == action.reqObject);
            if (found == -1 || !newState[found]) {
                return state;
            }

            newState[found].auditHistory = action.data;

            return Object.assign([], newState);
        }

        if (action.reqObject) {

            const newState = Object.assign([], state);
            const found = newState.findIndex(obj => obj[id] == action.reqObject);

            if (!action.data) {
                delete newState[found];
            } else if (found === -1) {
                newState.push(action.data);
            } else {
                newState[found] = action.data;
            }

            return Object.assign([], newState);
        }

        return Object.assign([], state, action.data);
    default:
        return state;
    };
};

const metaData = (state = null, action) => {

    switch (action.type) {

    case CHANGE_TENANT:
    case INVALIDATE_HTTP_DATA:

        return null;

    case 'QUEUES_HTTP_SUCCESS':

        if (!action.data || !action.data.metaData || action.reqObect) {
            return state;
        }

        return action.data.metaData;
    default:
        return state;
    }
};

const pending = (state = false, action) => {

    switch (action.type) {

    case 'QUEUES_HTTP_PENDING':
        return true;

    case 'QUEUES_HTTP_FAILURE':
    case 'QUEUES_HTTP_SUCCESS':
        return false;

    default:
        return state;
    }
};

export const queues = combineReducers({
    auditHistory,
    data,
    metaData,
    pending,
});
